module.exports = __webpack_public_path__ + "img/icon-white.ce5c02aa.png";